import { Button, Row, Col } from 'antd'

import { EditOutlined } from '@ant-design/icons'

import './TaskDrawer.style.less'

interface TextListProps {
  label?: string
  value?: string
  children?: React.ReactNode
  leftView?: React.ReactNode
  onClickEdit?: () => void
  isEditable?: boolean
}

function TextList(props: TextListProps) {
  const { onClickEdit, isEditable = false, children, value, leftView } = props

  var extraTextClass = ''

  switch (value) {
    case 'Done':
    case 'Pass':
    case '100%':
    case 'Approved':
      extraTextClass = 'text-pass'
      break
    case 'Fail':
    case 'Rejected':
      extraTextClass = 'text-fail'
      break
    default:
      break
  }

  if (children) {
    return (
      <Row className="mb-2 task-list-detail" align="middle">
        <Col span={9}>
          {leftView} <span className="label">{props.label}</span>
        </Col>
        <Col span={15}>{children}</Col>
      </Row>
    )
  }

  return (
    <Row className="mb-2 task-list-detail" align="middle">
      <Col span={9}>
        <span className="label">{props.label}</span>
      </Col>
      <Col span={13}>
        <span className="label">
          <b className={extraTextClass}>{value}</b>
        </span>
      </Col>
      {isEditable && (
        <Col span={2}>
          <Button
            onClick={onClickEdit}
            type="text"
            icon={<EditOutlined style={{ color: '#EF9747' }} />}
          />
        </Col>
      )}
    </Row>
  )
}

export default TextList
